import React from 'react'
import styled from 'styled-components'

export default (props) => (
  <ToogleWrapper {...props}>
    <Circle selected={props.selected} />
  </ToogleWrapper>
)

const ToogleWrapper = styled.div`
    border: 1px solid #BABABA;
    border-radius: 20px;
    position: relative;
    height: 14px;
    width: 34px;
    display: flex;
    align-items: center;
    cursor: pointer;
`

const Circle = styled.div`
    background: ${({ selected }) => selected ? `linear-gradient(270deg, #006736 0%, #93C13E 100%)` : `#676767`};
    border-radius: 50%;
    width: 20px;
    height: 20px;
    position: absolute;
    left: -5px;
    border: 2px solid #FFFFFF;
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.2);

    ${({ selected }) => selected && `
        left: 16px
    `}
`



// WEBPACK FOOTER //
// ./src/components/Toggle/index.js